import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './maininfoblock.module.scss';
import { useEffect, useState } from 'react';
import { fetchMainInfo } from '../../../services/api';

const MainInfoBlock = () => {
    const { settings } = useAccessibility();
    const [mainInfo, setMainInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    useEffect(() => {
        const fetchData = async () => {
            try {
                // Используем функцию для Django API
                const response = await fetchMainInfo();
                // Данные теперь в response.data[0].attributes
                setMainInfo(response.data[0].attributes);
                console.log('MainInfo data:', response.data[0].attributes);
            } catch (err) {
                console.error('Error fetching main info:', err);
                setError('Не удалось загрузить данные. Пожалуйста, попробуйте позже.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return <div>Загрузка...</div>;
    }

    if (error) {
        return <div>{error}</div>;
    }

    if (!mainInfo) {
        return <div>Данные не найдены</div>;
    }

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='ОСНОВНЫЕ СВЕДЕНИЯ ОБ ОРГАНИЗАЦИИ'
            headerColor={textColor}
            id='maininfo'
            aria-label="Основные сведения об организации"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Полное и сокращенное наименование */}
                        <section aria-labelledby="full-name">
                            <h4 id="full-name" className={style.header} style={{ color: textColor }}>
                                Полное наименование образовательной организации
                            </h4>
                            <p className={style.text} style={{ color: textColor }}>
                                {mainInfo.FullName}
                            </p>
                        </section>

                        <section aria-labelledby="short-name">
                            <h4 id="short-name" className={style.header} style={{ color: textColor }}>
                                Сокращенное наименование образовательной организации
                            </h4>
                            <p className={style.text} style={{ color: textColor }}>
                                {mainInfo.ShortName}
                            </p>
                        </section>

                        {/* Учредитель */}
                        <section aria-labelledby="founder">
                            <h4 id="founder" className={style.header} style={{ color: textColor }}>
                                Учредитель образовательной организации
                            </h4>
                            <address className={style.text} style={{ color: textColor }}>
                                {mainInfo.Founder?.Name}<br />
                                {mainInfo.Founder?.Address}
                            </address>
                        </section>

                        {/*Дата создания образовательной организации*/}
                        <section aria-labelledby="creation-date">
                            <h4 id="creation-date" className={style.header} style={{ color: textColor }}>
                                Дата создания образовательной организации
                            </h4>
                            <address className={style.text} style={{ color: textColor }}>
                                Образовательная организация создана в соответствии с распоряжением Губернатора Краснодарского края от 22.03.2024 № 55-р
                            </address>
                        </section>

                        {/* Место нахождения */}
                        <section aria-labelledby="legal-address">
                            <h4 id="legal-address" className={style.header} style={{ color: textColor }}>
                                Место нахождения образовательной организации
                            </h4>
                            <address className={style.text} style={{ color: textColor }}>
                                {mainInfo.Location}
                            </address>
                        </section>

                        {/* Режим работы */}
                        <section aria-labelledby="working-hours">
                            <h4 id="working-hours" className={style.header} style={{ color: textColor }}>
                                Режим и график работы образовательной организации
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>График работы администрации ГБУ ДО КК «СШОР «Самбо»:</p>
                                <p>понедельник-четверг с 09.00 до 13.00 час.; с 13:48 до 18.00
                                час., пятница с 09.00 до 13.00 час.; с 13.48 до 17.00 час.</p>
                                <p>Выходные: суббота, воскресенье</p>
                                {mainInfo.CoachSchedule?.data?.attributes?.url && (
                                    <Link
                                        href={`${mainInfo.CoachSchedule.data.attributes.url}`}
                                        height='fit-content'
                                        color={linkColor}
                                        fontFamily='Roboto, sans-serif'
                                        fontSize='1.25rem'
                                        fontWeight='500'
                                        children='Посмотреть расписание'
                                        aria-label="Расписание"
                                    />
                                )}
                            </div>
                        </section>

                        {/* Контакты */}
                        <section aria-labelledby="contacts">
                            <h4 id="contacts" className={style.header} style={{ color: textColor }}>
                                Контактный телефон и адрес электронной почты
                            </h4>
                            <address className={style.text} style={{ color: textColor }}>
                                Телефон: {mainInfo.Phone}<br />
                                Электронная почта: <Link 
                                    href={`mailto:${mainInfo.Email}`} 
                                    children={mainInfo.Email} 
                                    color={linkColor}
                                    aria-label="Написать письмо в организацию"
                                /><br />
                                Адреса в социальных сетях: {' '}
                                {mainInfo.SocialNetworks?.VK && (
                                    <Link 
                                        href={mainInfo.SocialNetworks.VK} 
                                        children="ВКонтакте" 
                                        color={linkColor}
                                        aria-label="Страница организации ВКонтакте - откроется в новой вкладке"
                                    />
                                )}
                                {mainInfo.SocialNetworks?.Telegram && (
                                    <Link 
                                        href={mainInfo.SocialNetworks.Telegram} 
                                        children="Telegram" 
                                        color={linkColor}
                                        aria-label="Телеграм-канал организации - откроется в новой вкладке"
                                    />
                                )}
                            </address>
                        </section>

                        {/* Места осуществления образовательной деятельности (лицензированные) */}
                        <section aria-labelledby="licensed-locations">
                            <h4 id="licensed-locations" className={style.header} style={{ color: textColor }}>
                                Места осуществления образовательной деятельности (лицензированные)
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>
                                Места осуществления образовательной деятельности при использовании сетевой формы реализации образовательных программ; места проведения практики; места проведения практической подготовки обучающихся; места проведения государственной итоговой аттестации - отсутствуют.
                                </p>
                                <p>Образовательная деятельность осуществляется {mainInfo.ShortName} только в местах, включенных в лицензию на осуществление образовательной деятельности:</p>
                                <ul>
                                    {mainInfo.filials?.data?.map((filial) => (
                                        <li key={`licensed-${filial.id}`}>
                                            {filial.attributes.Address}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </section>

                        {/* Государственная аккредитация */}
                        <section aria-labelledby="accreditation">
                            <h4 id="accreditation" className={style.header} style={{ color: textColor }}>
                                Государственная аккредитация
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>Государственная аккредитация отсутствует (не предусмотрена)</p>
                            </div>
                        </section>
                    </div>

                    {/* Лицензия */}
                    <section aria-labelledby="license" className={style.wrapperBottom}>
                        <h4 id="license" className={style.license} style={{ color: textColor }}>
                            Лицензия на осуществление образовательной деятельности
                        </h4>
                        <div className={style.licenseInfo} style={{ color: textColor }}>
                            {mainInfo.License?.data?.attributes?.url && (
                                <Link
                                    href={`${mainInfo.License.data.attributes.url}`}
                                    height='fit-content'
                                    color={linkColor}
                                    fontFamily='Roboto, sans-serif'
                                    fontSize='1.25rem'
                                    fontWeight='500'
                                    children='Выписка из реестра лицензий на осуществление образовательной деятельности'
                                    aria-label="Скачать выписку из реестра лицензий - откроется в новой вкладке"
                                />
                            )}
                        </div>
                    </section>
                </div>
            </FadeIn>
        </Block>
    )
}

export default MainInfoBlock;